var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('nav',[_c('ul',[_c('li',[_c('a',{attrs:{"href":"/project"}},[_vm._v("Project Intro")])]),_c('li',[_c('a',{attrs:{"href":"/dashboard"}},[_vm._v("Dashboard")])]),_c('li',[_c('a',{attrs:{"href":"/infrahub"}},[_vm._v("Infrahub")])])])])])
}]

export { render, staticRenderFns }